import React from 'react';
import styled from 'styled-components';

import { useColor } from '../../../modules/contexts/Color/useColor';

interface StatusVinculosProps {
  value?: string;
}

const StatusBadge = styled.div<{ bgColor: string; textColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  padding: 8px 4px;
  border-radius: 6px;
  /* font-size: 0.75rem; */
  text-align: center;
  font-weight: 500;
  color: ${({ textColor }) => textColor};
  white-space: nowrap;
`;

export const STATUS_VINCULOS_COR: Record<string, string> = {
  Ativo: 'Verde-Amazônia',
  Pendente: 'Status BG - Amarelo',
};

export const StatusVinculosCell: React.FC<StatusVinculosProps> = ({
  value,
}) => {
  const { getHexByNome } = useColor();

  if (!value) return null;

  const nomeCor = STATUS_VINCULOS_COR[value] ?? 'Status BG - Cinza';

  const bgColor = getHexByNome(nomeCor, '#dddddddd');

  const textColor = 'black';

  return (
    <StatusBadge bgColor={bgColor} textColor={textColor}>
      {value}
    </StatusBadge>
  );
};
